import { ImageWithFallback } from '../../../../components/ImageWithFallback';
import type { Technology } from '../../../../domain/technology';
import { formatToMonthYear } from '../../../../services/timeFormat';

import { StyledDate, StyledImageWrapper, StyledSubcategory } from './styles';

export const TechnologiesTableRow = ({ item }: { item: Technology }) => {
  const { technologyId, technologyName, subCategory, installationDate } = item;
  return (
    <>
      <StyledImageWrapper>
        <ImageWithFallback imageUrl={`https://static-us-east-1.similarcdn.com/technographics/id=${technologyId}`} />
      </StyledImageWrapper>
      <div>
        <div>{technologyName}</div>
        <StyledSubcategory>{subCategory}</StyledSubcategory>
      </div>
      <StyledDate>{formatToMonthYear(installationDate)}</StyledDate>
    </>
  );
};
